import { useEffect } from 'react';
import { Button, Card, Col, Form, Input, Row, message } from 'antd';
import {
  useCompanyData,
  useUpdateCompanyAlert,
} from '../../../../../../../../Hooks/TT_ELD/Companies';

type MyObjectType = {
  [key: string | number]: any;
};

const normalize = (value: any) => {
  if (value === '' || value === undefined || value === null) return null;
  return value;
};

const IdleTrucksAlertsTab = ({ companyId }: { companyId: any }) => {
  const [form] = Form.useForm();

  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(companyId);
  const { mutate: updateCompanyAlert, isLoading: isPending } = useUpdateCompanyAlert();

  useEffect(() => {
    form.setFieldsValue({
      telegramChatId: data?.telegramChatId,
    });
  }, [data?.telegramChatId, form]);

  const onSubmit = (values: any) => {
    const telegramChatId = normalize(values.telegramChatId);

    if (data?.telegramChatId === telegramChatId) {
      message.warning('No changes detected');
      return;
    }

    updateCompanyAlert(
      {
        companyId,
        body: {
          telegramChatId,
        },
      },
      {
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Card loading={isLoading || isFetching} style={{ width: '100%' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        onFinishFailed={onFinishFailed}
        name="idle-trucks-alerts-form"
        initialValues={{
          telegramChatId: data?.telegramChatId,
        }}
      >
        <Row gutter={[16, 10]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <Form.Item label="Idle Trucks Alerts (3 Days) Chat ID" name="telegramChatId">
              <Input placeholder="Enter Chat ID" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isPending}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default IdleTrucksAlertsTab;
